export const SET_SHOW_MODAL = 'SET_SHOW_MODAL_CUSTOM_GROUP';
export const SET_SUCCESS = 'SET_SUCCESS_CUSTOM_GROUP';
export const CREATE_CUSTOM_GROUP_REQUEST = 'CREATE_CUSTOM_GROUP_REQUEST';
export const CREATE_CUSTOM_GROUP_SUCCESS = 'CREATE_CUSTOM_GROUP_SUCCESS';
export const CREATE_CUSTOM_GROUP_FAILURE = 'CREATE_CUSTOM_GROUP_FAILURE';
export const UPDATE_CUSTOM_GROUP_REQUEST = 'UPDATE_CUSTOM_GROUP_REQUEST';
export const UPDATE_CUSTOM_GROUP_SUCCESS = 'UPDATE_CUSTOM_GROUP_SUCCESS';
export const UPDATE_CUSTOM_GROUP_FAILURE = 'UPDATE_CUSTOM_GROUP_FAILURE';
export const FETCH_CUSTOM_GROUP_BY_ID_REQUEST = 'FETCH_CUSTOM_GROUP_BY_ID_REQUEST';
export const FETCH_CUSTOM_GROUP_BY_ID_SUCCESS = 'FETCH_CUSTOM_GROUP_BY_ID_SUCCESS';
export const FETCH_CUSTOM_GROUP_BY_ID_FAILURE = 'FETCH_CUSTOM_GROUP_BY_ID_FAILURE';
export const DELETE_CUSTOM_GROUP_REQUEST = 'DELETE_CUSTOM_GROUP_REQUEST';
export const DELETE_CUSTOM_GROUP_SUCCESS = 'DELETE_CUSTOM_GROUP_SUCCESS';
export const DELETE_CUSTOM_GROUP_FAILURE = 'DELETE_CUSTOM_GROUP_FAILURE';
export const SELECTED_EDIT_LMS_CUSTOM_GROUP = 'SELECTED_EDIT_LMS_CUSTOM_GROUP';
export const SELECTED_EDIT_LMS_USERS_CUSTOM_GROUP = 'SELECTED_EDIT_LMS_USERS_CUSTOM_GROUP';
export const SELECTED_EDIT_LMS_USER_GROUPS_CUSTOM_GROUP = 'SELECTED_EDIT_LMS_USER_GROUPS_CUSTOM_GROUP';
